import { Link, useLocation } from "react-router-dom";
import AdminAccess from "./AdminAccess";
import { CONTACTO, IconInstagram, IconMail, IconWhatsApp } from "./Social";

export default function Footer() {
    const { pathname } = useLocation();

    return (
        <>
            {/* Cada página termina con una salida a contacto (menos contacto, pagar y admin) */}
            {!["/contacto", "/pagar"].includes(pathname) && !pathname.startsWith("/admin") && (
                <section className="cta-band">
                    <h2 className="display">¿Tienes partido,<br />torneo o <em>función?</em></h2>
                    <div className="hero-actions">
                        <a href={CONTACTO.whatsapp} className="btn btn-volt" target="_blank" rel="noreferrer">
                            <IconWhatsApp /> Escríbeme por WhatsApp
                        </a>
                    </div>
                </section>
            )}

            <footer className="site-footer">
                <span className="mono">© {new Date().getFullYear()} Lorely González · {CONTACTO.ciudad}</span>
                <div className="footer-links">
                    <Link to="/pagar" className="footer-pagar">Datos para transferir</Link>
                    <a href={CONTACTO.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><IconInstagram /></a>
                    <a href={CONTACTO.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp"><IconWhatsApp /></a>
                    <a href={`mailto:${CONTACTO.email}`} aria-label="Correo"><IconMail /></a>
                    <AdminAccess />
                </div>
            </footer>
        </>
    );
}
